import React from 'react';
import './TabStrategyProjectsConnection.less';

export default function TabStrategyProjectsConnection(props) {
  const { strategies } = props.data;
  return (
    <div className="tab-strategy-projects-connection">
      <ul>
        {strategies.map((item, i) => (
          <li key={i}>
            <div className="card">
              <div className="head">
                <h4>{item.name}</h4>
              </div>
              <div className="body">
                <p>Роль консорциума в рамках стратегического проекта:</p>
                <p>{item.influence}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
